import './Home.css'

const Home = () => {
  return (
    <div className={'container'}>
      <p style={{ fontSize: 50, color: '#fff' }}>Welcome to Aspect Web app 🙋‍♀️</p>
    </div>
  )
}

export default Home
